export const DEFAULT_DURATION = 2
export const DEFAULT_START = 0
